import { PureComponent } from "react";
import classnames from "classnames";
import { convertToArrayIfNeeded } from "utils/arrays";
import AssetComponent from "/components/core/asset/asset-component";
import ParagraphComponent from "../paragraph/paragraph-component";
import { isContentEmpty } from "/services/paragraph-service";

import { StyledParagraphAndAssetComponent, StyledContent } from "./paragraph-and-asset-columns-component.scss";

export default class ParagraphAndAssetComponent extends PureComponent {
  renderParagraphs(paragraphs) {
    return (
      <StyledContent className="content-body">
        {paragraphs.map((paragraph, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
        ))}
      </StyledContent>
    );
  }

  render() {
    let { content, asset, columnWidth, imageWidth } = this.props;
    let { body: contentBody } = content;

    contentBody = convertToArrayIfNeeded(contentBody);
    const withContent = !isContentEmpty(content);
    const withAsset = asset.image || asset.video;

    return (
      <StyledParagraphAndAssetComponent
        className={classnames("paragaph-and-asset-columns", {
          "asset-left": asset.side == "left"
        })}
      >
        <div className="top-line" style={{ width: columnWidth }}>
          {withContent && (
            <div className="content-column">
              <ParagraphComponent {...content} />
            </div>
          )}
          {withAsset && (
            <div className="asset-column">
              <AssetComponent {...asset} width={imageWidth} />
            </div>
          )}
        </div>
      </StyledParagraphAndAssetComponent>
    );
  }
}

ParagraphAndAssetComponent.defaultProps = {
  content: {},
  asset: {}
};
